
export default {
  layout: 'blank',

}
